import React, { useEffect, useState } from 'react';
import gql from 'graphql-tag';

import { InputDlg } from './input-dialog';
import { Form as FForm, Formik } from 'formik';
import {
  ButtonSearch,
  FieldInput,
  FormCol6,
  FilterProps,
  promiseModalSelect,
  FormRow,
  TableCellV8,
} from 'motion-components';
import { Form, Col } from 'react-bootstrap';
import { t } from 'i18next';
import { FormFieldCustomerDlg } from 'shared-pages';
import { useRootStore } from 'store';
import { useGetCustomerByGuid } from './fs-customer';
// import { promiseModalSelect } from './modal-select';

/* ----------------------------------
   Select Driver with Modal Search
   ---------------------------------- */
type Props = {
  initValueId: string;
  initValueName: string;
  onValueChange: (valueId: string, valueName: string) => void;
  required?: boolean;
  initFilters?: {} | (() => {});
};

export const FieldDriverDlg = ({
  initValueId = undefined,
  initValueName = '',
  onValueChange,
  required = false,
  initFilters = {},
}: Props) => {
  const { appStore } = useRootStore();
  const valueChanged = (valueId, valueName) => {
    onValueChange(valueId, valueName);
  };

  return (
    <InputDlg
      valueId={initValueId}
      valueName={initValueName}
      onDlgClick={async (event) => {
        const filters = typeof initFilters === 'function' ? initFilters() : initFilters;
        const autoFetchData = !!filters?.cstGuid;
        const res = await promiseModalSelectDriver({
          initFilters: filters,
          appStore,
          autoFetchData,
        });
        return { newId: res?.guid, newName: res?.driverName };
      }}
      onValueChange={valueChanged}
    />
  );
};

// -------------------------------------------------------------------------------
// Modal Select Customer
// -------------------------------------------------------------------------------

const gqlGetDrivers = gql`
  query getVehicleDrivers($where: String, $offset: Int, $limit: Int, $order: String) {
    getVehicleDrivers(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        guid
        driverName
        customer {
          guid
          name
        }
      }
      recordCount
    }
  }
`;

const columns = [
  {
    id: 'driverName',
    header: 'Ονοματεπώνυμο Οδηγού',
    columnName: 'Ονοματεπώνυμο Οδηγού',
    accessorKey: 'driverName',
    orderByField: 'driverName',
    cell: TableCellV8,
    size: 120,
  },
  {
    id: 'cstGuid',
    header: 'Φυσικό ή Νομικό Πρόσωπο',
    columnName: 'Φυσικό ή Νομικό Πρόσωπο',
    accessorKey: 'customer.name',
    orderByField: 'customer.name',
    cell: TableCellV8,
    size: 120,
  },
];

// -------------------------------------------------------------------------------
// Filters
// -------------------------------------------------------------------------------
const buildWhereFromFilters = (values) => {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText)
      where = {
        ...where,
        ...{
          driverName: { $like: '%' + values.searchText + '%' },
        },
      };
    if (values.cstGuid) {
      where = { ...where, cstGuid: values.cstGuid };
    }
  }
  return where;
};

const Filters: (props: FilterProps) => JSX.Element = ({ onChange, initialValues }) => {
  console.log('$$$ $$$ [fs-driver] initialValues', initialValues);
  const [customerInitialized, setCustomerInitialized] = useState(false);
  const [cstName, setCstName] = useState('');
  const [get] = useGetCustomerByGuid(initialValues?.cstGuid);
  useEffect(() => {
    async function fetchCst() {
      if (initialValues?.cstGuid) {
        const res = await get();
        const cstName = res?.data?.getCustomers.data[0].name;
        setCstName(cstName);
      }
      setCustomerInitialized(true);
    }
    fetchCst();
  }, [initialValues]);
  return (
    <Formik initialValues={initialValues ? initialValues : { searchText: '' }} onSubmit={onChange}>
      <Form as={FForm}>
        <FormRow className="mb-3 align-items-end">
          <FieldInput
            as={FormCol6}
            name="searchText"
            id="searchText"
            label="Ονοματεπώνυμο Οδηγού"
            type="search"
          />
          <Col className="ps-0 pe-0 me-3 ">
            <ButtonSearch size="sm" type="submit" className="float-end mb-2" />
          </Col>
        </FormRow>
        <FormRow className="mb-3 align-items-end">
          {customerInitialized && (
            <FormFieldCustomerDlg
              name={'cstGuid'}
              as={FormCol6}
              initValueId={initialValues.cstGuid}
              initValueName={cstName}
              onValueChange={(valueId, valueName) => {}}
            />
          )}
        </FormRow>
      </Form>
    </Formik>
  );
};

// -------------------------------------------------------------------------------

export const promiseModalSelectDriver = (props) => {
  return promiseModalSelect({
    ...props,
    title: 'Επιλογή Οδηγού Οχήματος',
    columns,
    gqlQuery: gqlGetDrivers,
    buildWhereFromFilters: buildWhereFromFilters,
    initFilters: props.initFilters,
    Filters: Filters,
    orderBy: 'driverName',
  });
};
// -------------------------------------------------------------------------------

